import React, { type ReactNode } from 'react'

import { useModalContext } from '@fourthwall/components'

import { PaymentMethodRequiredModalView } from './PaymentMethodRequiredModalView'

export type PaymentMethodRequiredModalContainerProps = {
  title?: string
  subtitle?: ReactNode
  withChargeLimit?: boolean
  submitLabel?: string
  onSuccess: () => void
  onCancel?: () => void
}

export const PaymentMethodRequiredModalContainer = (
  props: PaymentMethodRequiredModalContainerProps,
) => {
  const {
    title = 'Add a new payment method',
    subtitle,
    submitLabel = 'Save and continue',
    withChargeLimit = true,
    onSuccess,
    onCancel,
  } = props
  const { close, open } = useModalContext()

  const handleSuccess = () => {
    close()
    onSuccess()
  }

  const handleAddPaymentMethodClose = () => {
    open(PaymentMethodRequiredModalContainer, props)
  }

  const handleClose = () => {
    close()
    onCancel?.()
  }

  return (
    <PaymentMethodRequiredModalView
      title={title}
      subtitle={subtitle}
      submitLabel={submitLabel}
      withChargeLimit={withChargeLimit}
      onSuccess={handleSuccess}
      onClose={handleClose}
      onAddPaymentMethodClose={handleAddPaymentMethodClose}
    />
  )
}
